import i18next from 'i18next';

const getCountries = () => ({
  af: { name: i18next.t('Afghanistan') },
  ax: { name: i18next.t('Åland Islands') },
  al: { name: i18next.t('Albania') },
  dz: { name: i18next.t('Algeria') },
  as: { name: i18next.t('American Samoa') },
  ad: { name: i18next.t('Andorra') },
  ao: { name: i18next.t('Angola') },
  ai: { name: i18next.t('Anguilla') },
  aq: { name: i18next.t('Antarctica') },
  ag: { name: i18next.t('Antigua and Barbuda') },
  ar: { name: i18next.t('Argentina') },
  am: { name: i18next.t('Armenia') },
  aw: { name: i18next.t('Aruba') },
  au: { name: i18next.t('Australia') },
  at: { name: i18next.t('Austria') },
  az: { name: i18next.t('Azerbaijan') },
  bs: { name: i18next.t('Bahamas') },
  bh: { name: i18next.t('Bahrain') },
  bd: { name: i18next.t('Bangladesh') },
  bb: { name: i18next.t('Barbados') },
  by: { name: i18next.t('Belarus') },
  be: { name: i18next.t('Belgium') },
  bz: { name: i18next.t('Belize') },
  bj: { name: i18next.t('Benin') },
  bm: { name: i18next.t('Bermuda') },
  bt: { name: i18next.t('Bhutan') },
  bo: { name: i18next.t('Bolivia (Plurinational State of)') },
  bq: { name: i18next.t('Bonaire, Sint Eustatius and Saba') },
  ba: { name: i18next.t('Bosnia and Herzegovina') },
  bw: { name: i18next.t('Botswana') },
  bv: { name: i18next.t('Bouvet Island') },
  br: { name: i18next.t('Brazil') },
  io: { name: i18next.t('British Indian Ocean Territory') },
  bn: { name: i18next.t('Brunei Darussalam') },
  bg: { name: i18next.t('Bulgaria') },
  bf: { name: i18next.t('Burkina Faso') },
  bi: { name: i18next.t('Burundi') },
  cv: { name: i18next.t('Cabo Verde') },
  kh: { name: i18next.t('Cambodia') },
  cm: { name: i18next.t('Cameroon') },
  ca: { name: i18next.t('Canada') },
  ky: { name: i18next.t('Cayman Islands') },
  cf: { name: i18next.t('Central African Republic') },
  td: { name: i18next.t('Chad') },
  cl: { name: i18next.t('Chile') },
  cn: { name: i18next.t('China') },
  cx: { name: i18next.t('Christmas Island') },
  cc: { name: i18next.t('Cocos (Keeling) Islands') },
  co: { name: i18next.t('Colombia') },
  km: { name: i18next.t('Comoros') },
  cg: { name: i18next.t('Congo') },
  cd: { name: i18next.t('Congo (the Democratic Republic of the)') },
  ck: { name: i18next.t('Cook Islands') },
  cr: { name: i18next.t('Costa Rica') },
  ci: { name: i18next.t("Côte d'Ivoire") },
  hr: { name: i18next.t('Croatia') },
  cu: { name: i18next.t('Cuba') },
  cw: { name: i18next.t('Curaçao') },
  cy: { name: i18next.t('Cyprus') },
  cz: { name: i18next.t('Czechia') },
  dk: { name: i18next.t('Denmark') },
  dj: { name: i18next.t('Djibouti') },
  dm: { name: i18next.t('Dominica') },
  do: { name: i18next.t('Dominican Republic') },
  ec: { name: i18next.t('Ecuador') },
  eg: { name: i18next.t('Egypt') },
  sv: { name: i18next.t('El Salvador') },
  gq: { name: i18next.t('Equatorial Guinea') },
  er: { name: i18next.t('Eritrea') },
  ee: { name: i18next.t('Estonia') },
  sz: { name: i18next.t('Eswatini') },
  et: { name: i18next.t('Ethiopia') },
  fk: { name: i18next.t('Falkland Islands (Malvinas)') },
  fo: { name: i18next.t('Faroe Islands') },
  fj: { name: i18next.t('Fiji') },
  fi: { name: i18next.t('Finland') },
  fr: { name: i18next.t('France') },
  gf: { name: i18next.t('French Guiana') },
  pf: { name: i18next.t('French Polynesia') },
  tf: { name: i18next.t('French Southern Territories') },
  ga: { name: i18next.t('Gabon') },
  gm: { name: i18next.t('Gambia') },
  ge: { name: i18next.t('Georgia') },
  de: { name: i18next.t('Germany') },
  gh: { name: i18next.t('Ghana') },
  gi: { name: i18next.t('Gibraltar') },
  gr: { name: i18next.t('Greece') },
  gl: { name: i18next.t('Greenland') },
  gd: { name: i18next.t('Grenada') },
  gp: { name: i18next.t('Guadeloupe') },
  gu: { name: i18next.t('Guam') },
  gt: { name: i18next.t('Guatemala') },
  gg: { name: i18next.t('Guernsey') },
  gn: { name: i18next.t('Guinea') },
  gw: { name: i18next.t('Guinea-Bissau') },
  gy: { name: i18next.t('Guyana') },
  ht: { name: i18next.t('Haiti') },
  hm: { name: i18next.t('Heard Island and McDonald Islands') },
  va: { name: i18next.t('Holy See') },
  hn: { name: i18next.t('Honduras') },
  hk: { name: i18next.t('Hong Kong') },
  hu: { name: i18next.t('Hungary') },
  is: { name: i18next.t('Iceland') },
  in: { name: i18next.t('India') },
  id: { name: i18next.t('Indonesia') },
  ir: { name: i18next.t('Iran (Islamic Republic of)') },
  iq: { name: i18next.t('Iraq') },
  ie: { name: i18next.t('Ireland') },
  im: { name: i18next.t('Isle of Man') },
  il: { name: i18next.t('Israel') },
  it: { name: i18next.t('Italy') },
  jm: { name: i18next.t('Jamaica') },
  jp: { name: i18next.t('Japan') },
  je: { name: i18next.t('Jersey') },
  jo: { name: i18next.t('Jordan') },
  kz: { name: i18next.t('Kazakhstan') },
  ke: { name: i18next.t('Kenya') },
  ki: { name: i18next.t('Kiribati') },
  kp: { name: i18next.t("Korea (the Democratic People's Republic of)") },
  kr: { name: i18next.t('Korea (the Republic of)') },
  kw: { name: i18next.t('Kuwait') },
  kg: { name: i18next.t('Kyrgyzstan') },
  la: { name: i18next.t("Lao People's Democratic Republic") },
  lv: { name: i18next.t('Latvia') },
  lb: { name: i18next.t('Lebanon') },
  ls: { name: i18next.t('Lesotho') },
  lr: { name: i18next.t('Liberia') },
  ly: { name: i18next.t('Libya') },
  li: { name: i18next.t('Liechtenstein') },
  lt: { name: i18next.t('Lithuania') },
  lu: { name: i18next.t('Luxembourg') },
  mo: { name: i18next.t('Macao') },
  mg: { name: i18next.t('Madagascar') },
  mw: { name: i18next.t('Malawi') },
  my: { name: i18next.t('Malaysia') },
  mv: { name: i18next.t('Maldives') },
  ml: { name: i18next.t('Mali') },
  mt: { name: i18next.t('Malta') },
  mh: { name: i18next.t('Marshall Islands') },
  mq: { name: i18next.t('Martinique') },
  mr: { name: i18next.t('Mauritania') },
  mu: { name: i18next.t('Mauritius') },
  yt: { name: i18next.t('Mayotte') },
  mx: { name: i18next.t('Mexico') },
  fm: { name: i18next.t('Micronesia (Federated States of)') },
  md: { name: i18next.t('Moldova (the Republic of)') },
  mc: { name: i18next.t('Monaco') },
  mn: { name: i18next.t('Mongolia') },
  me: { name: i18next.t('Montenegro') },
  ms: { name: i18next.t('Montserrat') },
  ma: { name: i18next.t('Morocco') },
  mz: { name: i18next.t('Mozambique') },
  mm: { name: i18next.t('Myanmar') },
  na: { name: i18next.t('Namibia') },
  nr: { name: i18next.t('Nauru') },
  np: { name: i18next.t('Nepal') },
  nl: { name: i18next.t('Netherlands') },
  nc: { name: i18next.t('New Caledonia') },
  nz: { name: i18next.t('New Zealand') },
  ni: { name: i18next.t('Nicaragua') },
  ne: { name: i18next.t('Niger') },
  ng: { name: i18next.t('Nigeria') },
  nu: { name: i18next.t('Niue') },
  nf: { name: i18next.t('Norfolk Island') },
  mk: { name: i18next.t('North Macedonia') },
  mp: { name: i18next.t('Northern Mariana Islands') },
  no: { name: i18next.t('Norway') },
  om: { name: i18next.t('Oman') },
  pk: { name: i18next.t('Pakistan') },
  pw: { name: i18next.t('Palau') },
  ps: { name: i18next.t('Palestine, State of') },
  pa: { name: i18next.t('Panama') },
  pg: { name: i18next.t('Papua New Guinea') },
  py: { name: i18next.t('Paraguay') },
  pe: { name: i18next.t('Peru') },
  ph: { name: i18next.t('Philippines') },
  pn: { name: i18next.t('Pitcairn') },
  pl: { name: i18next.t('Poland') },
  pt: { name: i18next.t('Portugal') },
  pr: { name: i18next.t('Puerto Rico') },
  qa: { name: i18next.t('Qatar') },
  re: { name: i18next.t('Réunion') },
  ro: { name: i18next.t('Romania') },
  ru: { name: i18next.t('Russian Federation') },
  rw: { name: i18next.t('Rwanda') },
  bl: { name: i18next.t('Saint Barthélemy') },
  sh: { name: i18next.t('Saint Helena, Ascension and Tristan da Cunha') },
  kn: { name: i18next.t('Saint Kitts and Nevis') },
  lc: { name: i18next.t('Saint Lucia') },
  mf: { name: i18next.t('Saint Martin (French part)') },
  pm: { name: i18next.t('Saint Pierre and Miquelon') },
  vc: { name: i18next.t('Saint Vincent and the Grenadines') },
  ws: { name: i18next.t('Samoa') },
  sm: { name: i18next.t('San Marino') },
  st: { name: i18next.t('Sao Tome and Principe') },
  sa: { name: i18next.t('Saudi Arabia') },
  sn: { name: i18next.t('Senegal') },
  rs: { name: i18next.t('Serbia') },
  sc: { name: i18next.t('Seychelles') },
  sl: { name: i18next.t('Sierra Leone') },
  sg: { name: i18next.t('Singapore') },
  sx: { name: i18next.t('Sint Maarten (Dutch part)') },
  sk: { name: i18next.t('Slovakia') },
  si: { name: i18next.t('Slovenia') },
  sb: { name: i18next.t('Solomon Islands') },
  so: { name: i18next.t('Somalia') },
  za: { name: i18next.t('South Africa') },
  gs: { name: i18next.t('South Georgia and the South Sandwich Islands') },
  ss: { name: i18next.t('South Sudan') },
  es: { name: i18next.t('Spain') },
  lk: { name: i18next.t('Sri Lanka') },
  sd: { name: i18next.t('Sudan') },
  sr: { name: i18next.t('Suriname') },
  sj: { name: i18next.t('Svalbard and Jan Mayen') },
  se: { name: i18next.t('Sweden') },
  ch: { name: i18next.t('Switzerland') },
  sy: { name: i18next.t('Syrian Arab Republic') },
  tw: { name: i18next.t('Taiwan (Province of China)') },
  tj: { name: i18next.t('Tajikistan') },
  tz: { name: i18next.t('Tanzania, the United Republic of') },
  th: { name: i18next.t('Thailand') },
  tl: { name: i18next.t('Timor-Leste') },
  tg: { name: i18next.t('Togo') },
  tk: { name: i18next.t('Tokelau') },
  to: { name: i18next.t('Tonga') },
  tt: { name: i18next.t('Trinidad and Tobago') },
  tn: { name: i18next.t('Tunisia') },
  tr: { name: i18next.t('Türkiye') },
  tm: { name: i18next.t('Turkmenistan') },
  tc: { name: i18next.t('Turks and Caicos Islands') },
  tv: { name: i18next.t('Tuvalu') },
  ug: { name: i18next.t('Uganda') },
  ua: { name: i18next.t('Ukraine') },
  ae: { name: i18next.t('United Arab Emirates') },
  gb: { name: i18next.t('United Kingdom of Great Britain and Northern Ireland') },
  um: { name: i18next.t('United States Minor Outlying Islands') },
  us: { name: i18next.t('United States of America') },
  uy: { name: i18next.t('Uruguay') },
  uz: { name: i18next.t('Uzbekistan') },
  vu: { name: i18next.t('Vanuatu') },
  ve: { name: i18next.t('Venezuela (Bolivarian Republic of)') },
  vn: { name: i18next.t('Viet Nam') },
  vg: { name: i18next.t('Virgin Islands (British)') },
  vi: { name: i18next.t('Virgin Islands (U.S.)') },
  wf: { name: i18next.t('Wallis and Futuna') },
  eh: { name: i18next.t('Western Sahara') },
  ye: { name: i18next.t('Yemen') },
  zm: { name: i18next.t('Zambia') },
  zw: { name: i18next.t('Zimbabwe') },
});

export default getCountries;
